﻿export interface ICenterContract {
    rank: number,
    xpDate: string,
    chainId: number,
    cluster: number,
    position: number,
    dCenter: string,
    dAlias: string,
    rCenter: string,
    rAlias: string,
    shipMethod: string,
    transVendor: string,
    transportCost: number,
    dType: string,
    evalBilled: boolean,
    RecpPatientType: string,
    isCompat: boolean,
    recipientBloodType: string,
    donorBloodType: string,
    intendedDonorAlias: string,
    intendedDonorAbo: string,
    recipientCpra4: number
    waitTimeInMonths: number,
    waitTimeInYears: number
}